import { Cell } from './cell';

export class Grid {

	//create a map to get all the cells in the grid in a fast way
	#cells = new Map();

	constructor() {
		this.clear();
	}

	addCell( position, cell ) {
		this.#cells.set( JSON.stringify( position ), cell );
	}

	addRow( rowLength ) {

		// clean first & last rows and columns
		this.#clean();

		// get column count
		const cCount = this.numColumns;
		
		//get column lengths
		const columnWidths = this.#getColumnWidths();
		
		// add rows
		for( let i = 0; i < cCount; i++ ) {
			const cell = new Cell();
			cell.init( this.numRows, i, rowLength, columnWidths[ i ], this.structure, this );
			this.addCell( { row: this.numRows, column: i }, cell );
		}
		
		this.numRows ++;
	}

	addColumn( columnWidth ) {

		// clean first & last rows and columns
		this.#clean();

		// get column count
		const rCount = this.numRows;
		
		//get column lengths
		const rowLengths = this.#getRowLengths();
		
		// add rows
		for( let i = 0; i < rCount; i++ ) {
			const cell = new Cell();
			cell.init( i, this.numColumns, rowLengths[ i ], columnWidth, this.structure, this );
			this.addCell( { row: i, column: this.numColumns }, cell );
		}
		
		this.numColumns ++;
	}

	getCellsInRow( row ) {
		const cells = [];
		this.#cells.forEach( cell => {
			if( cell.row === row ) cells.push( cell );
		});
		
		//sort by row (smaller to bigger)
		cells.sort( ( a, b ) => a.row - b.row );

		return cells;
	}

	getCellsInColumn( column ) {
		const cells = [];
		this.#cells.forEach( cell => {
			if( cell.column === column ) cells.push( cell );
		});

		//sort by column (smaller to bigger)
		cells.sort( ( a, b ) => a.column - b.column );

		return cells;
	}

	getCell( row, column, onlyVisible = false ) {
		const cell = this.#cells.get( JSON.stringify( { row: row, column: column } ) );
		if( !onlyVisible ) return cell;
		else return cell && cell.visible ? cell : null;
	}

	getSelectedCells() {
		const cells = [];
		this.#cells.forEach( ( cell ) => {
			if( cell.selected ) cells.push( cell );
		});
		return cells;
	}

	#getColumnWidths() {
		// for each column get the width
		const widths = [];
		for( let i = 0; i < this.numColumns; i++ ) {
			let width = 0;
			for( let j = 0; j < this.numRows; j++ ) {
				const cell = this.getCell( j, i );
				if( cell ) { width = cell.width; break; }
			}
			widths.push( width );
		}
		return widths;
	}

	#getRowLengths() {
		// for each row get the length
		const lengths = [];
		for( let i = 0; i < this.numRows; i++ ) {
			let length = 0;
			for( let j = 0; j < this.numColumns; j++ ) {
				const cell = this.getCell( i, j );
				if( cell ) { length = cell.length; break; }
			}
			lengths.push( length );
		}
		return lengths;
	}

	#clean() {

		if( this.#cells.size === 0 ) return;

		let removed = false;
		// remove last row if there is no cell visible
		let lastRow = this.numRows - 1;
		let cells = this.getCellsInRow( lastRow ).filter( cell => cell.visible );
		if( cells.length === 0 ) {
			this.#cells.forEach( ( cell, key ) => {
				if( cell.row === lastRow ) this.#cells.delete( key );
			});
			this.numRows --;
			removed = true;
		}

		// remove last column if there is no cell visible
		let lastColumn = this.numColumns - 1;
		cells = this.getCellsInColumn( lastColumn ).filter( cell => cell.visible );
		if( cells.length === 0 ) {
			this.#cells.forEach( ( cell, key ) => {
				if( cell.column === lastColumn ) this.#cells.delete( key );
			});
			this.numColumns --;
			removed = true;
		}

		// remove first row if there is no cell visible
		cells = this.getCellsInRow( 0 ).filter( cell => cell.visible );
		if( cells.length === 0 ) {
			const keys = this.#cells.keys().toArray();
			for( let i = 0; i < keys.length; i++) {
				const key = keys[i];
				const cell = this.#cells.get( key );
				this.#cells.delete( key );
				//if not on the first row, move it
				if( cell.row > 0 ) {
					cell.row --;
					this.addCell( { row: cell.row, column: cell.column }, cell );
				}
			}
			this.numRows --;
			removed = true;
		}

		// remove first column if there is no cell visible
		cells = this.getCellsInColumn( 0 ).filter( cell => cell.visible );
		if( cells.length === 0 ) {
			const keys = this.#cells.keys().toArray();
			for( let i = 0; i < keys.length; i++) {
				const key = keys[i];
				const cell = this.#cells.get( key );
				this.#cells.delete( key );
				//if not on the first column, move it
				if( cell.column > 0 ) {
					cell.column --;
					this.addCell( { row: cell.row, column: cell.column }, cell );
				}
			}
			this.numColumns --;
			removed = true;
		}

		if( removed ) {
			//clean until there is no empty row or column on the sides
			this.#clean();
		}
	}

	clear() {

		//remove all data from cells
		this.#cells.clear();
		this.numRows = 0;
		this.numColumns = 0;
		this.options = '';
		this.structure = '';
	}
}